import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initParallaxScroll() {
    const components = document.querySelectorAll(".parallax-scroll");

    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
            components.forEach((component) => {
                const img = component.querySelector(".parallax-scroll__img");
                const content = component.querySelector(".container");

                if (img) {
                    gsap.to(img, {
                        y: "10%",
                        ease: "none",
                        scrollTrigger: {
                            trigger: component,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true,
                        },
                    });
                }

                if (content) {
                    gsap.to(content, {
                        y: "-15%",
                        ease: "none",
                        scrollTrigger: {
                            trigger: component,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true,
                        },
                    });
                }
            });
        },
    });
}
